import {getSensorData} from './get-sensor-data';

/*
* Show single sensor chart in Sidebar Box.
* */
export const showSensorChart = (curSensorId, curSensorLabel) => {
    // Generate current chart.
    getSensorData(curSensorId, 'WEEK', 'c-box-building-stats__chart--1', 'LineChart', curSensorLabel);
}
